import { injectStyle } from "./../../../../utils/style";
import { h } from "./../../../../utils/createElement";
import { __assign, __extends } from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import toFragment from '../util/mapSelf';
import MonthPanel from '../month/MonthPanel';
import YearPanel from '../year/YearPanel';
import DecadePanel from '../decade/DecadePanel';
import dayjs from '../dayjs';
import Header from '../../Header';
injectStyle("components/DatePicker/rc-calendar/style/common/header.css", "[data-dui-0-122-5~=\"dui-calendar-header\"]{padding:16px 16px 0;line-height:30px;text-align:center}[data-dui-0-122-5~=\"dui-calendar-header\"]>a{display:inline-block;width:30px;padding:0 5px;font-weight:700;line-height:34px;text-align:center}[data-dui-0-122-5~=\"dui-calendar-header\"]>a:hover{color:#175ceb;cursor:pointer}[data-dui-0-122-5~=\"dui-calendar-header\"] [data-dui-0-122-5~=\"dui-calendar-prev-month-btn\"]{left:38px;width:16px;height:16px;background:url(../img/arrow_single@2x.png) no-repeat 50%/contain;-webkit-transform:rotate(180deg);transform:rotate(180deg)}[data-dui-0-122-5~=\"dui-calendar-header\"] [data-dui-0-122-5~=\"dui-calendar-next-month-btn\"]{right:38px;width:16px;height:16px;background:url(../img/arrow_single@2x.png) no-repeat 50%/contain}[data-dui-0-122-5~=\"dui-calendar-month-select\"],[data-dui-0-122-5~=\"dui-calendar-year-select\"]{display:inline-block;padding:0 4px;color:var(--text-ultrastrong,rgba(0,0,0,.88));cursor:pointer;font-size:16px;font-weight:500;line-height:34px}[data-dui-0-122-5~=\"dui-calendar-month-select\"]:hover,[data-dui-0-122-5~=\"dui-calendar-year-select\"]:hover{color:#175ceb}");
var CalendarHeader = (function (_super) {
    __extends(CalendarHeader, _super);
    function CalendarHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { yearPanelReferer: null };
        _this.nextMonth = function () {
            _this.setMonthByDelta(1);
        };
        _this.previousMonth = function () {
            _this.setMonthByDelta(-1);
        };
        _this.nextYear = function () {
            _this.setYearByDelta(1);
        };
        _this.previousYear = function () {
            _this.setYearByDelta(-1);
        };
        _this.setYear = function (year) {
            var _a = _this.props, value = _a.value, onValueChange = _a.onValueChange;
            var next = value.clone();
            next.set('year', year);
            onValueChange(next);
        };
        _this.setMonth = function (month) {
            var _a = _this.props, value = _a.value, onValueChange = _a.onValueChange;
            var next = value.clone();
            next.set('month', month - 1);
            onValueChange(next);
        };
        _this.onMonthSelect = function (value) {
            var _a = _this.props, onPanelChange = _a.onPanelChange, onMonthSelect = _a.onMonthSelect, onValueChange = _a.onValueChange;
            onPanelChange(value, 'date');
            if (onMonthSelect) {
                onMonthSelect(value);
            }
            else {
                onValueChange(value);
            }
        };
        _this.onYearSelect = function (value) {
            var yearPanelReferer = _this.state.yearPanelReferer;
            var _a = _this.props, onPanelChange = _a.onPanelChange, onValueChange = _a.onValueChange;
            var referer = yearPanelReferer;
            _this.setState({ yearPanelReferer: null });
            onPanelChange(value, referer);
            onValueChange(value);
        };
        _this.onDecadeSelect = function (value) {
            var _a = _this.props, onPanelChange = _a.onPanelChange, onValueChange = _a.onValueChange;
            onPanelChange(value, 'year');
            onValueChange(value);
        };
        _this.changeYear = function (direction) {
            if (direction > 0) {
                _this.nextYear();
            }
            else {
                _this.previousYear();
            }
        };
        _this.showMonthPanel = function () {
            var onPanelChange = _this.props.onPanelChange;
            onPanelChange(null, 'month');
        };
        _this.showYearPanel = function (referer) {
            var onPanelChange = _this.props.onPanelChange;
            _this.setState({ yearPanelReferer: referer });
            onPanelChange(null, 'year');
        };
        _this.showDecadePanel = function () {
            var onPanelChange = _this.props.onPanelChange;
            onPanelChange(null, 'decade');
        };
        return _this;
    }
    CalendarHeader.prototype.setYearByDelta = function (delta) {
        var _a = this.props, value = _a.value, onValueChange = _a.onValueChange;
        var next = value.clone();
        next.add(delta, 'years');
        onValueChange(next);
    };
    CalendarHeader.prototype.setMonthByDelta = function (delta) {
        var _a = this.props, value = _a.value, onValueChange = _a.onValueChange;
        var next = value.clone();
        next.add(delta, 'months');
        onValueChange(next);
    };
    CalendarHeader.prototype.renderPrevNextBtn = function (type, directionType) {
        var _a = this.props, prefixCls = _a.prefixCls, locale = _a.locale;
        var props = {
            year: {
                onClick: {
                    prev: this.previousYear,
                    next: this.nextYear,
                }[directionType],
                title: {
                    prev: locale.previousYear,
                    next: locale.nextYear,
                }[directionType],
            },
            month: {
                onClick: {
                    prev: this.previousMonth,
                    next: this.nextMonth,
                }[directionType],
                title: {
                    prev: locale.previousMonth,
                    next: locale.nextMonth,
                }[directionType],
            },
        }[type];
        return (h("span", __assign({ className: prefixCls + "-" + directionType + "-" + type + "-btn", role: "button", tabIndex: "0", onKeyDown: Function.prototype }, props)));
    };
    CalendarHeader.prototype.renderMonthYearElement = function () {
        var _this = this;
        var props = this.props;
        var prefixCls = props.prefixCls, locale = props.locale, value = props.value;
        if (!value) {
            return null;
        }
        var year = (h("span", { className: prefixCls + "-year-select", role: "button", tabIndex: "0", title: locale.yearSelect, onClick: function () { return _this.showYearPanel('date'); }, onKeyDown: Function.prototype }, value.format(locale.yearFormat)));
        var localeData = value.localeData();
        var month = (h("span", { className: prefixCls + "-month-select", role: "button", tabIndex: "0", title: locale.monthSelect, onClick: this.showMonthPanel, onKeyDown: Function.prototype }, locale.monthFormat ? value.locale(locale.name).format(locale.monthFormat) : localeData.monthsShort(value)));
        var monthBeforeYear = locale.monthBeforeYear;
        return (h("span", { className: prefixCls + "-" + (monthBeforeYear ? 'my-select' : 'ym-select') }, toFragment(monthBeforeYear ? [month, year] : [year, month])));
    };
    CalendarHeader.prototype.render = function () {
        var _this = this;
        var _a = this.props, prefixCls = _a.prefixCls, locale = _a.locale, mode = _a.mode, value = _a.value, enableNext = _a.enableNext, enablePrev = _a.enablePrev, disabledMonth = _a.disabledMonth, renderFooter = _a.renderFooter, monthCellRender = _a.monthCellRender, monthCellContentRender = _a.monthCellContentRender;
        var panel = {
            month: (h(MonthPanel, { cellRender: monthCellRender, changeYear: this.changeYear, contentRender: monthCellContentRender, disabledDate: disabledMonth, locale: locale, renderFooter: renderFooter, rootPrefixCls: prefixCls, value: value, onSelect: this.onMonthSelect, onYearPanelShow: function () { return _this.showYearPanel('month'); } })),
            year: (h(YearPanel, { defaultValue: value, locale: locale, renderFooter: renderFooter, rootPrefixCls: prefixCls, onDecadePanelShow: this.showDecadePanel, onSelect: this.onYearSelect })),
            decade: (h(DecadePanel, { defaultValue: value, locale: locale, renderFooter: renderFooter, rootPrefixCls: prefixCls, onSelect: this.onDecadeSelect })),
        }[mode] || null;
        return (h("div", { className: prefixCls + "-header" },
            h("div", { style: { position: 'relative' } },
                h(Header, { selectedYear: value.year(), selectedMonth: value.month() + 1, onYearChange: this.setYear, onMonthChange: this.setMonth, onPrev: this.previousMonth, onNext: this.nextMonth })),
            panel));
    };
    return CalendarHeader;
}(React.Component));
CalendarHeader.propTypes = {
    disabledMonth: PropTypes.func,
    enableNext: PropTypes.bool,
    enablePrev: PropTypes.bool,
    locale: PropTypes.oneOfType([PropTypes.object]),
    mode: PropTypes.oneOf(['year', 'month', 'decade', 'date', 'time']),
    monthCellContentRender: PropTypes.func,
    monthCellRender: PropTypes.func,
    prefixCls: PropTypes.string,
    renderFooter: PropTypes.func,
    value: PropTypes.instanceOf(dayjs),
    onMonthSelect: PropTypes.func,
    onPanelChange: PropTypes.func,
    onValueChange: PropTypes.func,
};
CalendarHeader.defaultProps = {
    disabledMonth: undefined,
    enableNext: true,
    enablePrev: true,
    locale: {},
    mode: undefined,
    monthCellContentRender: undefined,
    monthCellRender: undefined,
    onMonthSelect: undefined,
    onPanelChange: Function.prototype,
    onValueChange: Function.prototype,
    prefixCls: '',
    renderFooter: undefined,
    value: undefined,
};
delete CalendarHeader.defaultProps.value;
export default CalendarHeader;
